import React from "react";

const Approach = () => {
  return (
    <div className='page'>
      <div className='container'>
        <div className='row'>
          <h3>This page is under construction.</h3>
        </div>
      </div>
    </div>
  );
};

export default Approach;
